<span [hidden]="hideValue" title={{params.value}}>{{params.value}}</span>